<template lang="pug">
main
  NavBarSca
  Loader(v-show="isLoading")
  ModalPrint(v-show="modalStatus" :title="titleModal" :content="contentModal" :ruta="ruta" @imprimirPorte="regresarDocumentados")
  section.section(v-show="!isLoading")
    .container
      .columns
        .column.is-half.is-offset-one-quarter.has-text-centered
          h3.title Documentar Carta Porte
      .columns
        .column.is-3
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Expendidor&nbsp
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                Expendidor(:expendidor="expendidor")
        .column.is-5
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Destinatario&nbsp
                span.tag.is-light(v-show="Object.keys(destino_sel).length > 0 ? true : false") {{ destino_sel.nombre }}
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                div.columns
                  div.column.is-12
                    TypeaheadDestinos(:options="destinosBD" :optionSelect="destino_sel" v-model="destino_sel" :isDisabled="isTH_disabled")
                    br
                    CardDestino(:destino="destino_sel")
        .column.is-4
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Porteador&nbsp
                span.tag.is-light(v-show="Object.keys(porteador_sel).length > 0 ? true : false") {{ porteador_sel.nombre }}
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                TypeaheadPorteadores(:options="porteadoresBD" :optionSelect="porteador_sel" v-model="porteador_sel" :isDisabled="isTH_disabled")
                br
                CardPorteador(:porteador="porteador_sel")
      .columns
        .column.is-6
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Datos de Facturación&nbsp
                span.tag.is-light(v-show="isComplete_DatosFacturacion") Completos
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                .columns
                  .field
                    input#inpLibre.is-checkradio.is-dark(type='checkbox' v-model='isLibre')
                    label.is-size-6(for='inpLibre') Libre
                .columns
                  .column.is-4
                    .field
                      .control
                        .select.is-primary
                          select(v-model="empresaSel")
                            option(v-for="emp in empresas" :value="emp" ) {{ emp.nombre }}
                  .column.is-4
                    .field
                      .control
                        .select.is-primary
                          select(v-model="grupoSel")
                            option(v-for="gr in gruposFilter" :value="gr" ) {{ gr.nombre }}
                  .column.is-4
                    .field
                      .control
                        .select.is-primary
                          select(v-model="subGrupoSel")
                            option(v-for="subG in subGruposFilter" :value="subG" ) {{ subG.nombre }} - ({{ subG.compania }})
        .column.is-3
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Datos del Tanque&nbsp
                span.tag.is-light Datos Completos
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                .columns
                  TypeaheadOperadores(:options="operadoresBD" :optionSelect="operadorSel" v-model="operadorSel" :isDisabled="isTH_disabled")
                .columns
                  .field
                    label.label Placas
                      .control.has-icons-left.has-icons-right
                        input.input.is-primary(
                          type='text',
                          placeholder='Placas',
                          v-model="placas"
                        )
                .columns
                  .field
                    label.label Magnatel
                      .control.has-icons-left.has-icons-right
                        input.input.is-primary(
                          type='text',
                          placeholder='Magnatel',
                          v-model="magnatel"
                        )
                .columns
                  .field
                    label.label Presión
                      .control.has-icons-left.has-icons-right
                        input.input.is-primary(
                          type='text',
                          placeholder='Presión salida',
                          v-model="presionTanque"
                        )
                .columns
                  .field
                    label.label Sellos
                      .control.has-icons-left.has-icons-right
                        input.input.is-primary(
                          type='text',
                          placeholder='sellos',
                          v-model="sellos"
                        )
        .column.is-3
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Datos Financieros&nbsp
                span.tag.is-light {{ `Valor Unit. ${parseFloat(valores.valorUnitario).toFixed(2)}` }}
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                CardValores(:vu="valores")
      .columns
        .column.is-12
          BulmaAccordion(
            :dropdown="true"
            :icon="'caret'"
            :caretAnimation={
              duration: '0.9s',
              timerFunc: 'ease-in-out'
            }
            :slide={
              duration: '0.9s',
              timerFunc: 'ease'
            }
          )
            BulmaAccordionItem
              p.title.is-4.has-text-weight-normal(slot='title')
                | Autotanques Cargados&nbsp
              i.material-icons(slot='icon') more_vert
              .high(slot='content')
                .columns
                  .column.is-6
                    .columns
                      .column.is-6
                        TypeaheadPG(:options="autotanquesBD" :optionSelect="pgSel" v-model="pgSel" :isDisabled="isCNP")
                      .column.is-6(v-show="verButton_CNPG")
                        .columns
                          .column
                            a.button.is-black.is-small.is-rounded(@click="show_FormCNPG")
                              | Cambiar Nombre PG
                        .columns(v-show="verForm_CNPG")
                          .column.is-8
                            .field
                              label.label Nuevo Nombre
                                .control.has-icons-left.has-icons-right
                                  input.input.is-primary(
                                    type='text',
                                    placeholder='RP-0000',
                                    v-model="nombrePG_nuevo"
                                  )
                        .columns(v-show="verForm_CNPG")
                          .column.is-6
                            a.button.is-block.is-small.is-black.is-rounded(@click="saveCNPG")
                              | Guardar
                          .column.is-6
                            a.button.is-block.is-small.is-rounded(@click="hide_FormCNPG")
                              | Cancelar
                  .column.is-6
                    CardDatosCC(:carga="pgSel" :valorUnitario="valores.valorUnitario" :acceso="acceso" :empresa="empresaSel"  @cargaTotal="setCargaTotal" @contenidoLitros="setContenidoLitros")
      .columns.has-text-centered(v-show="datosFaltantes.length > 0")
        .column.is-12
          .notification
            .field.is-grouped.is-grouped-multiline
              .control(v-for="datosF in datosFaltantes")
                .tags
                  span.tag.is-danger.is-light {{ datosF }}
      .columns.has-text-centered
        .column.is-offset-4.is-4
          span.tag.is-black {{ valorCargaTotal | currency }}
      .columns
        .column.is-offset-4.is-4
        button.button.is-black.is-rounded.is-block(@click="checkFormularios" :disabled="disableSendingData")
            | Guardar Embarque
    .columns.column-blanco
</template>

<script>
  import NavBarSca from '@/components/sca_Componentes/layout/irge/NavBarSca.vue'
  import Expendidor from './Expendidor.vue'
  import TypeaheadDestinos from '../componentes/TypeaheadDestinos.vue'
  import TypeaheadPorteadores from '../componentes/TypeaheadPorteadores.vue'
  import TypeaheadOperadores from '../componentes/TypeaheadOperadores.vue'
  import ModalPrint from '../componentes/ModalPrint.vue'
  import TypeaheadPG from '../componentes/TypeaheadPG.vue'
  import CardPorteador from '../componentes/CardPorteador.vue'
  import CardDestino from '../componentes/CardDestino.vue'
  import CardValores from '../componentes/CardValores.vue'
  import CardDatosCC from '../componentes/CardDatosCC.vue'
  import Loader from '@/components/shared/Loader.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import sca_irgeServices from '@/services/sca/irge.js'
  import api_ducter_energy from '@/services/sca/apiDucterEnergy.js'
  import api_ducter_movenergy from '@/services/sca/apiDucterMoveEnergy.js'

  export default {
    name: 'Documentar_IRGE',
    components: { NavBarSca, Loader, BulmaAccordion, BulmaAccordionItem, TypeaheadDestinos, TypeaheadOperadores, TypeaheadPG, TypeaheadPorteadores, Expendidor, CardDestino, CardPorteador, CardValores, CardDatosCC, ModalPrint },
    data() {
      return {
        expendidor: {
          nombre: 'DUCTOS DEL ALTIPLANO S.A. DE C.V.(IRGE ATOTONILCO)',
          clave: 'DDA-DO-EMB',
          telefono: '01 591 916 5373',
          direccion: 'CARR. JOROBAS-TULA KM. 10.5, EJIDO EL PEDREGAL, ATOTONILCO DE TULA HGO, C.P. 42980',
        },
        disableSendingData: true,
        isLoading: true,
        porteadoresBD: [],
        porteador_sel: {},
        destinosBD: [],
        destino_sel: {},
        isTH_disabled: false,
        autotanquesBD: [],
        pgSel: {},
        operadoresBD: [],
        operadorSel: {},
        placas: null,
        magnatel: null,
        presionTanque: null,
        sellos: null,
        valores: {},
        verCardDestino: false,
        verCardPorteador: false,
        valorCargaTotal: 0,
        empresas: [],
        empresaSel: {},
        grupos: [],
        grupoSel: {},
        gruposFilter: [],
        subGrupos: [],
        subGrupoSel: {},
        subGruposFilter: [],
        datosFaltantes: [],
        isComplete_DatosFacturacion: false,
        noEmbarque: null,
        fechaJornada: '',
        modalStatus: false,
        titleModal: '',
        contentModal: '',
        ruta: '',
        acceso: {},
        nombreEmbarque: '',
        nombrePG_nuevo: null,
        verForm_CNPG: false,
        verButton_CNPG: false,
        isCNP: false,
        isLibre: false,
        contenidoLitros: 0,
      }
    },
    watch: {
      acceso() {
            this.enableSubmitButton()
          },
      porteador_sel() {
        if (Object.keys(this.porteador_sel).length > 0) {
          this.verCardPorteador = true
        } else {
          this.verCardPorteador = false
        }
      },
      destino_sel() {
        if (Object.keys(this.destino_sel).length > 0) {
          this.verCardDestino = true
        } else {
          this.verCardDestino = false
        }
      },
      empresaSel() {
        if (!this.isLibre) {
          this.enableSubmitButton()
          this.filtrarGrupos()
        }
      },
      grupoSel() {
        if (!this.isLibre) {
          this.filtrarSubgrupos()
        }
      },
      subGrupoSel() {
        this.checkDatosFacturacion()
      },
      pgSel() {
        this.checkAcceso()
        if (Object.keys(this.pgSel).length > 0) {
          this.verButton_CNPG = true
          this.nombrePG_nuevo = this.pgSel.pg
        } else {
          this.verButton_CNPG = true
          this.nombrePG_nuevo = null
        }
      },
      isLibre() {
        if (this.isLibre) {
          this.empresaSel = this.empresas.find( e => e.id == 0)
          this.gruposFilter = this.grupos
          this.subGruposFilter = this.subGrupos
          this.grupoSel = this.gruposFilter.find( g => g.id == 0)
          this.subGrupoSel = this.subGruposFilter.find( s => s.id == 0)
        }
      },
    },
    methods: {
      enableSubmitButton(){
        console.log('enableSubmitButton()')
            console.log(this.acceso.hasOwnProperty('id'))
            if(this.acceso.hasOwnProperty('id')){

              if (this.empresaSel.id == 2) {

                if(this.acceso.pesoEntrada != 0
                  && this.acceso.magnatel != 0
                  && this.acceso.presion != 0
                  && this.acceso.sellos.length > 0){

                    // disableSendingData = false Sifnifica que el boton esta activo (puede guardar)
                    // disableSendingData = true Sifnifica que el boton esta inactivo (no puede guardar)

                    //Valida si la empresa seleccionada es Movenergy


                    // si es movenergy verifcia que su id de programa sea diferente a 0
                    if(this.acceso.programa_nomcar_id != 0){
                      this.disableSendingData = false
                      // si es diferente de cero habilita el boton
                    }else{
                      this.disableSendingData = true
                      // siempre else por si cambian de selecciones invalida
                    }

                }else{
                  this.disableSendingData = true
                }
              } else {
                this.disableSendingData = false
              }


            }else{
              console.log('No tiene acceso')
              this.disableSendingData = true
            }
      },
      iniciarComponente() {
        let ahora = moment().format('YYYY-MM-DD HH:mm:ss')
        let hoy = moment()
        let ahoraFinal = moment('05:15am', 'h:mma')
        if (ahoraFinal.isBefore(ahora)) {
          this.fechaJornada = hoy.format('YYYY-MM-DD')
        } else {
          this.fechaJornada = hoy.subtract(1, 'days').format('YYYY-MM-DD')
        }
        this.obtenerEmpresas()
      },
      obtenerPorteadores () {
        sca_irgeServices.getPorteadores()
          .then(resPort => {
            this.porteadoresBD = resPort
            this.obtenerDestinatarios()
          })
          .catch(e => console.log(e))
      },
      obtenerDestinatarios () {
        sca_irgeServices.getDestinos()
          .then(resPort => {
            this.destinosBD = resPort
            this.obtenerOperadores()
          })
          .catch(e => console.log(e))
      },
      obtenerOperadores () {
        sca_irgeServices.getOperadores()
          .then(resOper => {
            this.operadoresBD = resOper
            // this.obtenerAutos()
            this.obtenerValorUnitario()
          })
          .catch(e => console.log(e))
      },
      obtenerValorUnitario () {
        sca_irgeServices.getValorUnitario()
          .then( res => {
            this.valores = res[0]
            this.obtenerCargas()
          })
          .catch(e => console.log(e))
      },
      obtenerCargas () {
        sca_irgeServices.getPG_cargados()
          .then(res => {
            this.autotanquesBD = res
          })
          .catch(e => console.log(e))
        this.isLoading = false
      },
      setCargaTotal (val) {
        this.valorCargaTotal = val
      },
      setContenidoLitros (val) {
        this.contenidoLitros = val
      },
      checkFormularios () {
        this.datosFaltantes = []
        // if (Object.keys(this.destino_sel).length > 1 || Object.keys(this.porteador_sel).length) {
        if (Object.keys(this.destino_sel).length >= 1 && Object.keys(this.porteador_sel).length >= 1 && Object.keys(this.empresaSel).length >= 1 && Object.keys(this.grupoSel).length >= 1 && Object.keys(this.subGrupoSel).length >= 1 && Object.keys(this.pgSel).length >= 1 && Object.keys(this.operadorSel).length >= 1 && this.magnatel && this.placas && this.presionTanque) {
          if(this.empresaSel.id == 0 || this.grupoSel.id == 0 || this.subGrupoSel.id == 0) {
            if(this.empresaSel.id == 0){
              this.datosFaltantes.push('Falta seleccionar una compañia')
            }
            if(this.grupoSel.id == 0){
              this.datosFaltantes.push('Falta seleccionar un grupo')
            }
            if(this.subGrupoSel.id == 0){
              this.datosFaltantes.push('Falta seleccionar un subgrupo')
            }
          } else {
              this.guardarEmbarque()
          }
        } else {

          if (Object.keys(this.destino_sel).length == 0) {
            this.datosFaltantes.push('El destino es requerido.')
          }
          if (Object.keys(this.porteador_sel).length == 0) {
            this.datosFaltantes.push('El porteador es requerido.')
          }
          if (Object.keys(this.empresaSel).length == 0) {
            this.datosFaltantes.push('La Empresa es requerida.')
          }
          if (Object.keys(this.grupoSel).length == 0) {
            this.datosFaltantes.push('El grupo es requerido.')
          }
          if (Object.keys(this.subGrupoSel).length == 0) {
            this.datosFaltantes.push('El subgrupo es requerido.')
          }
          if (Object.keys(this.pgSel).length == 0) {
            this.datosFaltantes.push('El autotanque es requerido.')
          }
          if (Object.keys(this.operadorSel).length == 0) {
            this.datosFaltantes.push('El Operador es requerido.')
          }
          if (!this.magnatel) {
            this.datosFaltantes.push('El magnatel es requerido.')
          }
          if (!this.placas) {
            this.datosFaltantes.push('Las placas son requeridos.')
          }
          if (!this.presionTanque) {
            this.datosFaltantes.push('La Presión de salida es requerida.')
          }
        }
      },
      checkDatosFacturacion () {
        if ( Object.keys(this.empresaSel).length >= 1 && Object.keys(this.grupoSel).length >= 1 && Object.keys(this.subGrupoSel).length >= 1 ) {
          if (this.grupoSel.id == 0 || this.subGrupoSel.id == 0) {
            this.isComplete_DatosFacturacion= false
          } else {
            this.isComplete_DatosFacturacion = true
          }
        } else {
          this.isComplete_DatosFacturacion = false
        }
      },

      guardarEmbarque () {
        this.isLoading = true
        sca_irgeServices.buscarId()
          .then( resId => {
            this.noEmbarque = parseInt(resId[0].id) + 1
            if (this.noEmbarque > 0) {
              console.log(this.noEmbarque)
              let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
              let year = moment().format('YYYY')
              let dateReg = moment().format('YYYY-MM-DD')
              this.nombreEmbarque = `TERM/${year}/${this.noEmbarque}`
              sca_irgeServices.documentar(this.noEmbarque, this.pgSel.finCarga, this.expendidor.nombre, this.expendidor.clave, this.expendidor.direccion, this.expendidor.telefono, this.destino_sel.idDestinatario, this.destino_sel.nombre, this.destino_sel.clave, this.destino_sel.direccion, this.destino_sel.telefono, this.porteador_sel.id, this.porteador_sel.nombre, this.porteador_sel.clave, this.porteador_sel.rfc, this.placas, this.operadorSel.nombre, this.empresaSel.id, this.grupoSel.id, this.subGrupoSel.id, this.valorCargaTotal, this.valores.valorUnitario, this.magnatel, 'PROPANO', this.sellos, 'AMBIENTE', this.operadorSel.nombre, this.userLogin.nombre, this.pgSel.pg, this.pgSel.volumen20, this.pgSel.masaKgs, this.pgSel.presion, this.presionTanque, fechaReg, this.fechaJornada, this.nombreEmbarque, this.userLogin.id, this.pgSel.densidad20Corregida, this.contenidoLitros)
                .then( resp => {
                  console.log(resp)
                  if (resp.success) {
                    let fechaAcceso = ''
                    if (Object.keys(this.acceso).length > 0) {
                      fechaAcceso = this.acceso.fechaLlegada
                    } else {
                      fechaAcceso = null
                    }

                    sca_irgeServices.updateLlenado(this.pgSel.id, this.noEmbarque, fechaAcceso)
                      .then(resUp => {
                        if (resUp.success) {
                          sca_irgeServices.updateRecepcion_pg(this.acceso.id, fechaReg, this.pgSel.pg, this.noEmbarque)
                            .then( async (resUAcc) => {
                              console.log(resUAcc)
                              if (resUAcc.success) {
                                this.isLoading = false
                              } else {
                                this.isLoading = false
                                this.displayToast('bubble', resUAcc.repsuesta, 'ban', 'OK')
                              }

                              //  Mandar evento de documentado completo
                              if (this.empresaSel.id != 2) {
                                if (this.acceso.program_id > 0) {
                                  const galones = Math.round((parseInt(this.pgSel.masaKgs) / parseFloat(this.pgSel.densidad20Corregida)) * 0.264172)

                                  const dataEnergy = {
                                    pg: this.acceso.pg,
                                    program_id: this.acceso.program_id,
                                    status: {
                                      "event": "Despachado",
                                      "event_code": 5005,
                                      event_date: fechaReg,
                                    },
                                    meta_data :{
                                      terminal_id: 2,
                                      noEmbarque: parseInt(this.noEmbarque),
                                      fechaJ: this.pgSel.fechaRep,
                                      inicioCarga: this.pgSel.inicioCarga.substring(11,16),
                                      finCarga_llenado: this.pgSel.finCarga,
                                      fechaSalida: fechaReg,
                                      pg: this.pgSel.pg,
                                      nombrePorteador: this.porteador_sel.nombre,
                                      idCompania: parseInt(this.empresaSel.id),
                                      compania: this.empresaSel.nombre,
                                      idSubgrupo: this.subGrupoSel.id,
                                      subgrupo: this.subGrupoSel.nombre,
                                      nombreDestinatario: this.destino_sel.nombre,
                                      masa: parseInt(this.pgSel.masaKgs),
                                      masaStr: new Intl.NumberFormat('es-MX').format(this.pgSel.masaKgs),
                                      densidad: parseFloat(this.pgSel.densidad),
                                      densidad20: parseFloat(this.pgSel.densidad20Corregida),
                                      volumen: parseFloat(this.pgSel.volumen),
                                      volumen20: parseFloat(this.pgSel.volumen20),
                                      magnatel: `${parseFloat(this.magnatel)}%`,
                                      presionTanque: parseFloat(this.presionTanque),
                                      fechaLlegada: this.acceso.fechaLlegada.substring(11,16),
                                      finCarga: this.pgSel.finCarga.substring(11,16),
                                      fechaDoc: fechaReg.substring(11,16),
                                      litros: parseInt(this.contenidoLitros),
                                      galones: galones
                                    },
                                    meta_data_bascule: {
                                      terminal_id: "2",
                                      id_terminal: this.acceso.id,
                                      fecha: this.pgSel.fechaRep,
                                      grupoComp: this.subGrupoSel.id,
                                      claveAcceso: this.acceso.claveAcceso,
                                      porteador: this.porteador_sel.nombre,
                                      pg: this.pgSel.pg,
                                      llenadera: this.pgSel.llenadera,
                                      sellos: this.sellos,
                                      magnatel: this.magnatel,
                                      estado: this.acceso.estado,
                                      pesoEntrada: this.acceso.pesoEntrada,
                                      pesoSalida: this.acceso.pesoSalida,
                                      pesoPG: parseInt(this.pgSel.masaKgs),
                                      pesoNeto: this.acceso.pesoSalida - this.acceso.pesoEntrada,
                                      pesoFacturado: parseInt(this.pgSel.masaKgs),
                                      difMasa: (this.acceso.pesoSalida - this.acceso.pesoEntrada) - parseInt(this.pgSel.masaKgs),
                                    }
                                  }
                                  console.log("🚀 ~ file: Documentar_IRGE.vue:523 ~ .then ~ dataEnergy:", dataEnergy)

                                  await api_ducter_energy.updateProgram(dataEnergy)
                                    .then( response => { console.log(response)})
                                    .catch( e => console.log(e))
                                }
                              }else{

                                let fechaSalidaME = fechaReg.replace(/ /g, 'T');
                                let FechaPPME = this.pgSel.inicioCarga.replace(/ /g, 'T');
                                let FechaSPME = this.pgSel.finCarga.replace(/ /g, 'T');

                                const dataMovenergy = {
                                  "DatosHojaEmbarque":{
                                    "FechaOperacion": this.pgSel.fechaRep, // Formatear fecha
                                    "FechaEmbarque": dateReg, // Formatear fecha
                                    "NoEmbarque":this.noEmbarque,
                                    "CveDestinatario": this.isEmpty(this.destino_sel.clave) ? '99999' : this.destino_sel.clave,
                                    "NombreDestinatarioDest": this.destino_sel.nombre,
                                    "DireccionDestino": this.destino_sel.direccion,
                                    "CvePorteador":this.isEmpty(this.porteador_sel.clave) ? '99999' : this.porteador_sel.clave,
                                    "NombrePorteador": this.porteador_sel.nombre,
                                    "RFCPorteador": this.porteador_sel.rfc,
                                    "PlacasTracto": this.placas,
                                    "GrupoGasera": this.grupoSel.nombre,
                                    "NoTanque": this.acceso.pg,
                                    "PrcntLlenado": parseFloat(this.magnatel),
                                    "Masa": parseInt(this.pgSel.masaKgs),
                                    "Volumen": Math.round(parseInt(this.pgSel.masaKgs)/parseFloat(this.pgSel.densidad20Corregida)),
                                    "FechaSalida": fechaSalidaME
                                  },
                                  "DatosHojaPesaje":{
                                    "PlacasTracto": this.placas,
                                    "NombreOperador": this.operadorSel.nombre,
                                    "Transportista": this.porteador_sel.nombre,
                                    "NoTanque": this.acceso.pg,
                                    "PesoPP": this.acceso.pesoEntrada,
                                    "FechaPP": FechaPPME, // Formatear fecha
                                    "PesoSP": this.acceso.pesoSalida,
                                    "FechaSP": FechaSPME, // Formatear fecha
                                    "PesoNeto": this.acceso.pesoSalida - this.acceso.pesoEntrada,
                                    "EmpresaBascula": 'IRGE',
                                    "EsFull": this.acceso.es_full
                                  }
                                }
                                console.log(dataMovenergy)
                                await api_ducter_movenergy.sendData(dataMovenergy,this.acceso.programa_nomcar_id,'irge')
                                    .then( response => { console.log(response)})
                                    .catch( e => console.log(e))
                              }

                              this.verModalImprmir()
                            })
                            .catch(e4 => {
                              this.isLoading = false
                              this.displayToast('bubble', e4.message, 'ban', 'OK')
                            })
                        } else {
                          this.isLoading = false
                          this.displayToast('bubble', resUp.respuesta, 'ban', 'OK')
                        }
                      })
                      .catch(e2 => {
                        this.isLoading = false
                        this.displayToast('bubble', e2.message, 'ban', 'OK')
                      })

                  } else {
                    this.isLoading = false
                    this.displayToast('bubble', resp.respuesta, 'ban', 'OK')
                  }
                })
                .catch(e1 => {
                  this.isLoading = false
                  this.displayToast('bubble', e1.message, 'ban', 'OK')
                })
            } else {
              console.log('Embarque null o sin numero')
              this.displayToast('bubble', 'Embarque null o sin numero', 'ban', 'Ok')
            }
          })
          .catch(eID => {
            this.displayToast('bubble', eID.message, 'ban', 'OK')
            this.isLoading = false
          })
      },

      regresarDocumentados () {
        this.modalStatus = false
        this.$router.push('/IRGE/SCA/Documentacion')
      },

      checkAcceso () {
        sca_irgeServices.getAcceso_pg(this.pgSel.pg)
          .then(data => {
            if (data.length < 1) {
              this.acceso = {}
            } else {
              console.log("🚀 ~ file: Documentar_TPA.vue:584 ~ checkAcceso ~ data[0]:", data[0])
              this.acceso = data[0]
              console.log("🚀 ~ file: Documentar_TPA.vue:585 ~ checkAcceso ~ this.acceso:", this.acceso)
              this.magnatel = this.acceso.magnatel
              this.presionTanque = this.acceso.presion

              let arraySellos = []
              this.acceso.sellos.forEach(s => {
                arraySellos.push(s.sello)
              })
              // console.log(arraySellos)
              this.sellos = arraySellos.join(' / ')

              /* Revisar si tiene programa energy24-7 */
              if (this.acceso.program_id > 0) {
                console.log("🚀 ~ file: Documentar_TPA.vue:598 ~ checkAcceso ~ this.acceso.program_id:", this.acceso.program_id)

                /* Obtener el destino */
                this.destinosBD.map( d => {
                  if (d.idDestinatario == this.acceso.id_destino) {
                    console.log('Coincide')
                    this.destino_sel = d
                  }
                })
                console.log("🚀 ~ file: Documentar_TPA.vue:608 ~ checkAcceso ~ this.destino_sel:", this.destino_sel)

                /* Obtener transportista */
                this.porteadoresBD.map( p => {
                  if (parseInt(p.id) == this.acceso.id_transportista) {
                    console.log('Coincide')
                    this.porteador_sel = p
                  }
                })

                console.log("🚀 ~ file: Documentar_TPA.vue:612 ~ checkAcceso ~ this.porteador_sel:", this.porteador_sel)


                /* Obtener operador */
                this.operadoresBD.map( o => {
                  if (parseInt(o.id) == this.acceso.id_operador) {
                    console.log('Coincide')
                    this.operadorSel = o
                  }
                })
                console.log("🚀 ~ file: Documentar_TPA.vue:625 ~ checkAcceso ~ this.operadorSel:", this.operadorSel)

                /* Obtener data de autotanque */
                this.placas = this.acceso.placas

              } else {
                this.obtenerUltimoPorteador()
              }
              this.enableSubmitButton()
            }
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble', e.message, 'ban', 'OK')
          })
      },
      verModalImprmir () {
        const currentUrl = window.location.hostname
        const protocol = window.location.protocol
        this.ruta = `${protocol}//${currentUrl}/servidores/reportes/cartaPorte_Irge.php?emb=${this.noEmbarque}&n=${this.nombreEmbarque}`
        this.titleModal = 'Imprimir Carta Porte'
        this.contentModal = `EL embarque ${this.noEmbarque} ha sido registrado exitosamente.`
        this.modalStatus = true
      },
      show_FormCNPG () {
        this.verForm_CNPG = true
        this.isCNP = true
      },
      hide_FormCNPG () {
        this.verForm_CNPG = false
        this.isCNP = false
      },
      saveCNPG () {
        if (this.nombrePG_nuevo) {
          sca_irgeServices.cambiarNombrePG(this.pgSel.id, this.nombrePG_nuevo)
            .then((data) => {
              console.log(data)
              if (data.success) {
                let toast = this.$toasted.show(`Se ha actualizado el nombre del PG a: ${this.nombrePG_nuevo}`, {
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                this.obtenerCargas()
                this.verForm_CNPG = false
                this.verButton_CNPG = false
                this.isCNP = false
                this.nombrePG_nuevo = null
                this.pgSel = {}

              } else {
                let toast = this.$toasted.show(`Error: ${data.respuesta}`, {
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration : 3000,
                  iconPack: 'fontawesome',
                  icon: 'ban',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
              }
            })
            .catch((e)=> console.log(e))
        }
      },
      enviarEmailPropangol() {
        console.log('enviarEmailPropangol')
        sca_irgeServices.enviarCorreoPropangol(this.noEmbarque, this.nombreEmbarque)
          .then((data) => {
            console.log(data)
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: tema,
          position: "bottom-right",
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      filtrarGrupos() {
        if (this.empresaSel.id == 0) {
          return
        }
        this.gruposFilter = []
        this.subGruposFilter = []
        this.gruposFilter = this.grupos.filter( g => g.companias.includes(this.empresaSel.id) || g.id == 0)
        this.grupoSel = this.gruposFilter.find( g => g.id == 0)
        this.checkDatosFacturacion()
      },

      filtrarSubgrupos() {
        if (this.grupoSel.id == 0) {
          return
        }
        this.subGruposFilter = []
        const subgruposGrupos = this.subGrupos.filter( s => s.grupos.includes(this.grupoSel.id))

        const subgruposEmpresa = []
        this.subGruposFilter.push(this.subGrupos[0])
        subgruposGrupos.forEach(subgrupo => {
          const exist = subgrupo.gruposData.filter( sd => sd.id_compania == this.empresaSel.id)
          if (exist.length> 0) {
            this.subGruposFilter.push(subgrupo)
          }
        })
        this.subGrupoSel = this.subGruposFilter.find( s => s.id == 0)
        this.checkDatosFacturacion()
      },

      obtenerUltimoPorteador() {
        sca_irgeServices.getLastPorteador(this.pgSel.pg)
          .then((data) => {
            if (data.length > 0) {
              this.porteador_sel = {}
              const ultimoPorteador = data[0]
              const porteador = this.porteadoresBD.find( p => parseInt(p.id) === ultimoPorteador.idporteador)
              this.porteador_sel = porteador
            } else {
              this.porteador_sel = {}
              console.log('No hubo porteadores Anteriores')
            }
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },

      obtenerEmpresas(){
        sca_irgeServices.getEmpresasIRGE()
          .then((data) => {
            this.empresas = data
            this.empresaSel = this.empresas.find( e => e.id == 0)
            this.obtenerGrupos()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
      obtenerGrupos(){
        sca_irgeServices.getGruposIRGE()
          .then((data) => {
            this.grupos = data
            this.gruposFilter = this.grupos
            this.obtenerSubgrupos()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
      obtenerSubgrupos(){
        sca_irgeServices.getSubgruposIRGE()
          .then((data) => {
            this.subGrupos = data
            this.subGruposFilter = this.subGrupos
            this.obtenerPorteadores()
          })
          .catch( (e => {
            this.isLoading = false
            console.log(`Error: ${e.message}`)
          }))
      },
      formatDateWithOffset(date, offset) {

          let dateNew = new Date(date);
          let isoString = dateNew.toISOString().replace('Z', '');

          if(offset != null){
            isoString += offset;
          }

          return isoString;
      },
      isEmpty(value) {
        return (value == null || (typeof value === "string" && value.trim().length === 0));
      }
    },
    created () {
      this.iniciarComponente()
    },
      computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/Documentar_IRGE.vue